import AppsContainer from "../../components/UmmIACategories/AppsContainer";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import UmmIAEvTitleImg from "../../components/UmmIACategories/img/UmmIAEvTitleImg.png";

const UmmIAEvPage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIAEv"
        descripcion="Aplicaciones para evaluar y retroalimentar el aprendizaje"
        img={UmmIAEvTitleImg}
        alt="Imagen UmmIA Ev"
        primaryColor="#E29930"
        secondaryColor="#F8ED9B"
        thirdColor="#F1DB37"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIAEv" />
    </>
  );
};

export default UmmIAEvPage;
